/* eslint-disable */
 // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "axios";
import '@/assets/css/app.css'
import httpRequest from '@/httpRequest/index' // api: https://github.com/axios/axios

! function(r) {
  var n = window.webpackJsonp;
  window.webpackJsonp = function(e, u, c) {
    for (var f, i, p, a = 0, l = []; a < e.length; a++) i = e[a], o[i] && l.push(o[i][0]), o[i] = 0;
    for (f in u) Object.prototype.hasOwnProperty.call(u, f) && (r[f] = u[f]);
    for (n && n(e, u, c); l.length;) l.shift()();
    if (c)
      for (a = 0; a < c.length; a++) p = t(t.s = c[a]);
    return p
  };
  var e = {},
    o = {
      2: 0
    };

  function t(n) {
    if (e[n]) return e[n].exports;
    var o = e[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return r[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports
  }
  t.m = r, t.c = e, t.d = function(r, n, e) {
    t.o(r, n) || Object.defineProperty(r, n, {
      configurable: !1,
      enumerable: !0,
      get: e
    })
  }, t.n = function(r) {
    var n = r && r.__esModule ? function() {
      return r.default
    } : function() {
      return r
    };
    return t.d(n, "a", n), n
  }, t.o = function(r, n) {
    return Object.prototype.hasOwnProperty.call(r, n)
  }, t.p = "./", t.oe = function(r) {
    throw console.error(r), r
  }
}([]);



Vue.config.productionTip = false

// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
// Vue.prototype.isAuth = isAuth; // 权限方法
Vue.prototype.$axios = axios // ajax请求方法

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js